angular.module('acme.view.application.importExport.importExportJob.directives.importExportJobExecutionGrid', [
    'acme.common.service.utils',
    'acme.common.service.userPreferences'
])
.directive('importExportJobExecutionGrid', [function () {
    return {
        restrict: 'A',
        replace: true,
        scope: {
            job: '='
        },
        controller: 'importExportJobExecutionGridController',
        template: '<div><div data-ng-include="\'common/views/dataGrid/dataGrid.tpl.html\'" data-scope-property="importExportJobExecution" data-ng-controller="DataGridController"></div></div>'
    };
}]).filter('importExportDate', ['$filter', 'UserPreferencesService', function($filter, UserPreferencesService) {
    return function(input) {
        return $filter('date')(input, UserPreferencesService.getDateTimeFormat('sortDateTime'));
    };
}]).controller( 'importExportJobExecutionGridController',  [
    '$rootScope',
    '$scope',
    '$state',
    '$timeout',
    '$uibModal',
    'PermissionsService',
    'UtilsService',
    'ImportExportsApiService',
    'ImportJobExecutionsApiService',
    'JOB_TYPE',
    'JOB_EXECUTION_STATUS_TITLE',
    'GridStateFactory',
    'GridDefinitionFactory',

    function ImportExportListController($rootScope, $scope, $state, $timeout, $uibModal, PermissionsService, UtilsService, ImportExportsApiService, ImportJobExecutionsApiService, JOB_TYPE, JOB_EXECUTION_STATUS_TITLE, GridStateFactory, GridDefinitionFactory) {
        $scope.importExportJobExecution = {
            job: $scope.job,
            gridName: $state.current.name+'.grid.' + $scope.job.jobType,
            gridDefinition: new GridDefinitionFactory(),
            gridState: new GridStateFactory(),
            model: [],
            filtered: [],
            queryTimer: false,
            customFields: [],
            optionsOverride: {
                rowHeight: 30,
                data: 'importExportJobExecution.model',
                appScopeProvider: {
                    onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
                        self.gridState.updateGridState(newPage, pageSize);
                        if (sortField) {
                            self.gridState.updateGridState(null, null, sortField, null);
                        }
                        if(sortDirection) {
                            self.gridState.updateGridState(null, null, null, sortDirection);
                        }
                        self.getImportExport();
                    },
                    onDataGridSortChange: function(grid, columns, page) {
                        var data = columns[0];
                        self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
                        self.getImportExport();
                    },
                    onDblClick: function (item) {
                    },
                    createOrUpdateJob: function($event, job) {
                        self.openModal('importExportCreateJobModal',
                            'ImportExportCreateJobModalController',
                            $event, job);
                    },
                    openJobDeleteModal: function ($event, job) {
                        self.openModal('importExportDeleteJobModal',
                            'ImportExportDeleteJobModalController',
                            $event, job);
                    },

                    getStatusTitle: function (status) {
                        return JOB_EXECUTION_STATUS_TITLE[status] || JOB_EXECUTION_STATUS_TITLE.unknown;
                    },

                    clickJobExecution: function($event, id, jobId) {
                        if (!UtilsService.eventAlreadyFired($event)) {
                            $state.go('application.importExport.' + (self.job.jobType === JOB_TYPE.IMPORT ? 'jobExecution' : 'exportJobExecution'), { id: id, jobId: jobId });
                        }
                    },

                    openJobExecutionOutputsDownloadModal: function ($event, jobExecution) {
                        if (!UtilsService.eventAlreadyFired($event)) {
                            $uibModal.open({
                                templateUrl: 'views/application/views/importExport/exportJobExecution/exportJobExecutionOutputDownloadModal.tpl.html',
                                size: 'md',
                                controller: 'ExportJobExecutionOutputDownloadModalController',
                                controllerAs: '$ctrl',
                                resolve: {
                                    reportName: function () {
                                        return self.job.name;
                                    },
                                    executionId: jobExecution.id,
                                    outputs: function () {
                                        return jobExecution.jobExportExecutionOutputs;
                                    }
                                }
                            });
                        }
                    },
                    openJobExecutionDeleteModal: function ($event, jobExecution) {
                        if (UtilsService.eventAlreadyFired($event)) {
                            return;
                        }

                        var modal = $uibModal.open({
                            templateUrl: 'views/application/views/importExport/importExportJobExecution/importJobExecutionOutputDeleteModal.tpl.html',
                            size: 'md',
                            controller: 'ImportExportJobExecutionDeleteModalController',
                            controllerAs: '$ctrl',
                            resolve: {
                                reportName: function () {
                                    return self.job.name;
                                },
                                executionId: jobExecution.id
                            }
                        });

                        modal.result.then(function (wasDeleted) {
                            if (wasDeleted) {
                                self.getImportExport();
                            }
                        });
                    }
                },
                columnDefs: [
                    {
                        name: 'id',
                        field: 'id',
                        displayName: 'id',
                        cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="(grid.appScope ? grid.appScope : importExportJobExecution.optionsOverride.appScopeProvider).clickJobExecution($event, row.entity.id, row.entity.jobId)">{{row.entity.id}}</a></div>'
                    },
                    {
                        displayName: 'status',
                        field: 'status',
                        cellTemplate: '<div class="ui-grid-cell-contents">{{ (grid.appScope ? grid.appScope : importExportJobExecution.optionsOverride.appScopeProvider).getStatusTitle(row.entity.status) }}</div>'
                    }

                ],
                columnDefsImport: [
                    {
                        name: 'updatedOn',
                        field: 'updatedOn',
                        displayName: 'Last Updated',
                        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.updatedOn | importExportDate }}</div>'
                    },
                    {
                        name: 'createdOn',
                        field: 'createdOn',
                        displayName: 'Created on',
                        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.createdOn | importExportDate }}</div>'
                    },
                    {
                        name: 'importedCount',
                        field: 'importedCount',
                        displayName: 'Total Imported'
                    },
                    {
                        name: 'errorCount',
                        field: 'errorCount',
                        displayName: 'Total Errors'
                    },
                    {
                        displayName: 'Automatic Import',
                        name: 'autoImport',
                        field: 'autoImport',
                        enableSorting: false,
                        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.autoImport ? "Yes" : "No" }}</div>'
                    },
                    {
                        name: 'delete',
                        field: 'delete',
                        displayName: 'Delete',
                        enableSorting: false,
                        cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-show="row.entity.status === \'created\'" data-ng-click="(grid.appScope ? grid.appScope : importExportJobExecution.optionsOverride.appScopeProvider).openJobExecutionDeleteModal($event, row.entity)">Delete</a></div>'
                    }
                ],
                columnDefsExport: [
                    {
                        name: 'totalRecords',
                        field: 'totalRecords',
                        displayName: 'Total Records'
                    },
                    {
                        name: 'totalLoaded',
                        field: 'totalLoaded',
                        displayName: 'Total Exported'
                    },
                    {
                        name: 'startTime',
                        field: 'startTime',
                        displayName: 'Start Time',
                        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.startTime | importExportDate }}</div>'
                    },
                    {
                        name: 'completeTime',
                        field: 'completeTime',
                        displayName: 'Complete Time',
                        cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.completeTime | importExportDate }}</div>'
                    },
                    {
                        name: 'message',
                        field: 'message',
                        displayName: 'Message'
                    },
                    {
                        name: 'downloads',
                        field: 'downloads',
                        displayName: 'downloads',
                        enableSorting: false,
                        cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-show="row.entity.jobExportExecutionOutputs.length" data-ng-click="(grid.appScope ? grid.appScope : importExportJobExecution.optionsOverride.appScopeProvider).openJobExecutionOutputsDownloadModal($event, row.entity)">Downloads</a><span data-ng-hide="row.entity.jobExportExecutionOutputs.length">None</span></div>'
                    }
                ]
            },

            init: function() {
                self.optionsOverride.columnDefs = this.optionsOverride.columnDefs.concat(self.job.jobType === JOB_TYPE.IMPORT ? self.optionsOverride.columnDefsImport : self.optionsOverride.columnDefsExport);
                self.gridDefinition.init(this.gridName, this.optionsOverride, $state.current.name, $state.current.data.enablePreferences);

                $scope.$on('$destroy', $scope.$on('DataGrid::UserPreferencesLoaded', this.initData));
            },

            initData: function(e, data) {
                var props = self.gridDefinition.getGridState();
                self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
                self.getImportExport();
            },

            getImportExport: function() {
                var gridState = self.gridState.getGridState();
                var sortField = null;
                if (gridState.sortField && gridState.sortDirection) {
                    sortField = gridState.sortField + "," + gridState.sortDirection;
                }
                (self.job.jobType === JOB_TYPE.IMPORT ? ImportJobExecutionsApiService : ImportExportsApiService)
                    .list(self.job.id, gridState.page - 1,
                        gridState.pageSize,
                        sortField)
                        .then(self.success.getData, self.error.getData);
            },

            success: {
                init: function(response) {},
                getData: function (response) {
                    var data = response.data;

                    self.model = data._embedded ? data._embedded[self.job.jobType === JOB_TYPE.IMPORT ? 'jobExecutionVoList' : 'jobExportExecutionVoList'] : [];

                    self.gridDefinition.isLoaded = true;

                    $timeout(function() {
                        $scope.$broadcast('DataGrid::ResizeGrid', {
                            name: self.gridName,
                            datasetLength: self.model.length,
                            totalItems: data.page.totalElements
                        });

                    }, 10);
                }
            },

            error: {
                init: function(response) {},
                getData: function (data) {}
            }

        };

        var self = $scope.importExportJobExecution;
        self.init();
    }]);